module.exports = __webpack_public_path__ + "img/creative.dafe7b9.jpg";